var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMPermisosPorHora(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#2eccb6;}.cls-3,.cls-6{fill:#329be6;}.cls-4{fill:#0b5c96;}.cls-5{fill:#fff;}.cls-6{mix-blend-mode:multiply;}.cls-7{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m_permisos_por_hora"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Permisos"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.71,42.08a16.61,16.61,0,0,1,.72-4.86H5.91V27.09L.28,32.72a.4.4,0,0,0,0,.56L32.72,65.72a.4.4,0,0,0,.56,0L40.5,58.5A16.7,16.7,0,0,1,26.71,42.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.72,32.72,33.28.28a.4.4,0,0,0-.56,0L22.05,11h6.57V7.23h4.71l0,3.7h7V25.67a17.34,17.34,0,0,1,3-.28A16.71,16.71,0,0,1,59.82,39.18l5.9-5.9A.4.4,0,0,0,65.72,32.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M57.59,42.08A14.19,14.19,0,0,1,43.4,56.27c-.22,0-.43,0-.64,0L40.5,58.5a16.29,16.29,0,0,0,2.9.27A16.71,16.71,0,0,0,60.09,42.08a16.29,16.29,0,0,0-.27-2.9l-2.26,2.26C57.57,41.65,57.59,41.87,57.59,42.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M8.37,18.25h6.38l7.3-7.3H17.6V7.63a.39.39,0,0,0-.4-.4H13.3a.39.39,0,0,0-.4.4V11H6.31a.39.39,0,0,0-.4.4V27.09l2.46-2.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M43.4,25.39a17.34,17.34,0,0,0-3,.28V11.33a.4.4,0,0,0-.4-.4H33.35l0-3.31a.39.39,0,0,0-.4-.39H29a.4.4,0,0,0-.4.4V11H22.05l-7.3,7.3,23.12,0V29a14.33,14.33,0,0,1,2.53-.8,14.82,14.82,0,0,1,3-.32A14.18,14.18,0,0,1,57.56,41.44l2.26-2.26A16.71,16.71,0,0,0,43.4,25.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M29.21,42.08a14.31,14.31,0,0,1,2-7.31H8.37V24.63L5.91,27.09v9.74a.39.39,0,0,0,.4.4H27.43A16.68,16.68,0,0,0,40.5,58.5l2.26-2.26A14.18,14.18,0,0,1,29.21,42.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M43.4,27.89A14.15,14.15,0,0,0,37.87,29V18.22H8.37V34.78H31.25A14.18,14.18,0,1,0,43.4,27.89ZM30.81,23.1,21,32.92a.42.42,0,0,1-.57,0l-5-5a.4.4,0,0,1,0-.57l1.66-1.66a.4.4,0,0,1,.57,0l3,3.05,7.88-7.88a.42.42,0,0,1,.57,0l1.66,1.66A.42.42,0,0,1,30.81,23.1Zm.4,19.82a.34.34,0,0,1-.33-.34v-1a.33.33,0,0,1,.33-.33h2.67a.34.34,0,0,1,.34.33v1a.34.34,0,0,1-.34.34Zm6,6.48-1.89,1.89a.33.33,0,0,1-.47,0l-.71-.71a.33.33,0,0,1,0-.47l1.89-1.89a.33.33,0,0,1,.47,0l.71.71A.33.33,0,0,1,37.26,49.4Zm0-14.17-.71.71a.33.33,0,0,1-.47,0l-1.89-1.89a.33.33,0,0,1,0-.47l.71-.71a.33.33,0,0,1,.47,0l1.89,1.89A.33.33,0,0,1,37.26,35.23Zm12.28-.47,1.89-1.89a.33.33,0,0,1,.47,0l.71.71a.33.33,0,0,1,0,.47l-1.89,1.89a.33.33,0,0,1-.47,0l-.71-.71A.33.33,0,0,1,49.54,34.76Zm-7-4.87a.33.33,0,0,1,.33-.33h1a.33.33,0,0,1,.33.33v2.67a.33.33,0,0,1-.33.34h-1a.33.33,0,0,1-.33-.34Zm1.66,24.38a.33.33,0,0,1-.33.33h-1a.33.33,0,0,1-.33-.33V51.6a.33.33,0,0,1,.33-.34h1a.33.33,0,0,1,.33.34Zm3-9.36-1,1a.33.33,0,0,1-.47,0l-3.34-3.3a.33.33,0,0,1-.1-.24V34.9a.33.33,0,0,1,.33-.33h1.42a.33.33,0,0,1,.33.33v6.75l2.82,2.78A.34.34,0,0,1,47.27,44.91Zm5.34,5.67-.71.71a.33.33,0,0,1-.47,0L49.54,49.4a.33.33,0,0,1,0-.47l.71-.71a.33.33,0,0,1,.47,0l1.89,1.89A.33.33,0,0,1,52.61,50.58Zm3-7.66H52.92a.34.34,0,0,1-.34-.34v-1a.34.34,0,0,1,.34-.33h2.67a.33.33,0,0,1,.33.33v1A.34.34,0,0,1,55.59,42.92Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 42.57,
    y: 29.56,
    width: 1.67,
    height: 3.34,
    rx: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 42.57,
    y: 51.26,
    width: 1.67,
    height: 3.34,
    rx: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 30.88,
    y: 41.25,
    width: 3.34,
    height: 1.67,
    rx: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 52.58,
    y: 41.25,
    width: 3.34,
    height: 1.67,
    rx: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 49.4,
    y: 33.57,
    width: 3.34,
    height: 1.67,
    rx: 0.33,
    transform: "translate(-9.37 46.2) rotate(-45.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 34.06,
    y: 48.92,
    width: 3.34,
    height: 1.67,
    rx: 0.33,
    transform: "translate(-24.72 39.84) rotate(-45.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 34.89,
    y: 32.74,
    width: 1.67,
    height: 3.34,
    rx: 0.33,
    transform: "translate(-13.87 35.34) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 50.24,
    y: 48.09,
    width: 1.67,
    height: 3.34,
    rx: 0.33,
    transform: "translate(-20.22 50.69) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44.44,41.65V34.9a.33.33,0,0,0-.33-.33H42.69a.33.33,0,0,0-.33.33v7.48a.33.33,0,0,0,.1.24l3.34,3.3a.33.33,0,0,0,.47,0l1-1a.34.34,0,0,0,0-.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M29.15,20.87a.42.42,0,0,0-.57,0L20.7,28.75l-3-3.05a.4.4,0,0,0-.57,0l-1.66,1.66a.4.4,0,0,0,0,.57l5,5a.42.42,0,0,0,.57,0l9.82-9.82a.42.42,0,0,0,0-.57Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    width: 66,
    height: 66
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMPermisosPorHora);
export default __webpack_public_path__ + "static/media/m_permisos_por_hora.2038c008586142ebf9fe23c12c668ce7.svg";
export { ForwardRef as ReactComponent };